<template>
    <div class="container section-menu-page">
        <div class="section-title-wrap">
            <h2 class="section-title">{{ labels.title }}</h2>
        </div>
        <div>
            <div class="admin-home-card table-corporate-body main-menu-scroll-shell">
                <b-container style="padding: 18px 40px 40px;">
                    <b-row
                        id="home-buttons"
                        v-for="subMenu in visibleSubmenus"
                        :key="subMenu.id || subMenu.ruta"
                    >
                        <b-col md="4" class="p-2 admin-menu-card-col" col="3">
                            <button
                                type="button"
                                class="md-card admin-menu-card-button"
                                @click="goToRoute(subMenu)"
                            >
                                <div>
                                    <div>
                                        <div class="md-title-tarjeta">
                                            <span>{{ subMenu?.nombre }}</span>
                                        </div>
                                    </div>
                                </div>
                            </button>
                        </b-col>
                        <b-col md="8" class="p-2" col="3">
                            <div md-with-hover class="div-description">
                                <div>
                                    <div>
                                        <div class="md-title-description">
                                            <span>{{ subMenu?.descripcion }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </div>
        </div>
    </div>
</template>

<script>
import Menu from '../../services/Menu'
import SubMenu from '../../services/SubMenu'

export default {
    name: "Parametrizacion",
    data: () => ({
        listaSubMenu: []
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Parametrización",
                    coins: "Monedas",
                    exchangeRates: "Tasas de cambio",
                    tasasPatrimonio: "Patrimonio",
                    tasasPatrimoniod: "Tasas de Cambio del Patrimonio",
                    niif: "Niif",
                    niifNoControlante: "Niif No Controlante",
                    niifNoControlanted: "Niif para Participaciones No Controlantes",
                    gruposIntercos: "Grupos Intercompañías",
                    gruposIntercosd: "Administración de Grupos Intercompañías",
                    chartAccounts: "Plan de cuentas",
                    schemes: "Esquemas",
                    company: "Compañías",
                    levels: "EFE Directo",
                    levelsDirectEfe: "Consolidacion EFE Método Directo",
                    indirectLevel: "EFE Indirecto",
                    levelIndirectEfe: "Consolidacion EFE Método Indirecto",
                    reporteECP: "Reporte ECP",
                    reporteECPd: "Configuración de Reportes ECP",
                    reporteORI: "Reporte ORI",
                    reporteORId: "Configuración de Reportes ORI",
                    ajustes: "Ajustes",
                    ajustesd: "Ajustes de Consolidacion",
                    reclasifica: "Reclasifica",
                    reclasificad: "Reclasificacion de Saldos",
                    periodo: "Periodo",
                    periodod: "Administración de Periodos",
                    redefinicionfilas: "Redefinición de Filas",
                    redefinicionfilasd: "Redefinición de Filas y Columnas",
                    nivelesAdmIndirecto: "Niveles Adm Indirecto",
                    nivelesAdmIndirectod: "Administración de Niveles - Método Indirecto",
                }
            } else {
                return {
                    title: "Parametrization",
                    coins: "Coins",
                    exchangeRates: "Exchange rates",
                    tasasPatrimonio: "Heritage",
                    tasasPatrimoniod: "Heritage Exchange Rates",
                    niif: "Niif",
                    niifNoControlante: "Non-Controlling Interest Niif",
                    niifNoControlanted: "Niif for Non-Controlling Interests",
                    gruposIntercos: "Intercompany Groups",
                    gruposIntercosd: "Intercompany Groups Administration",
                    chartAccounts: "Chart of accounts",
                    schemes: "Schemes",
                    company: "Companies",
                    levels: "Direct Method EFE",
                    levelsDirectEfe: "Direct Method EFE Consolidation",
                    indirectLevel: "Indirect Method EFE",
                    levelIndirectEfe: "Indirect Method EFE Consolidation",
                    reporteECP: "ECP Report",
                    reporteECPd: "ECP Reports Configuration",
                    reporteORI: "ORI Report",
                    reporteORId: "ORI Reports Configuration",
                    ajustes: "Adjustments",
                    ajustesd: "Consolidation Adjustments",
                    reclasifica: "Reclassify",
                    reclasificad: "Reclassify Accounting Statement",
                    periodo: "Period",
                    periodod: "Period Administration",
                    redefinicionfilas: "Row Redefinition",
                    redefinicionfilasd: "Row and Column Redefinition",
                    nivelesAdmIndirecto: "Admin Levels Indirect",
                    nivelesAdmIndirectod: "Level Administration - Indirect Method",
                }
            }
        },
        visibleSubmenus() {
            return this.listaSubMenu.length > 0 ? this.listaSubMenu : this.buildFallbackSubmenus()
        }
    },
    methods: {
        goToRoute(subMenu) {
            const targetRoute = this.resolveRoute(subMenu)
            if (!targetRoute) return

            const routeExists = this.$router.getRoutes().some(route => route.path === targetRoute)
            if (!routeExists) {
                console.error(`La ruta ${targetRoute} no existe en el router`)
                this.$toast?.error(`La ruta ${targetRoute} no está disponible`)
                return
            }
            this.$router.push(targetRoute)
        },
        resolveRoute(subMenu) {
            const rawPath = String(subMenu?.ruta || "").trim()
            const rawName = String(subMenu?.nombre || "").trim().toLowerCase()
            const normalizedPath = rawPath
                ? (rawPath.startsWith("/") ? rawPath : `/${rawPath}`)
                : ""

            const routeMapByName = {
                monedas: "/currency",
                coins: "/currency",
                "tasas de cambio": "/tasaCambio",
                "exchange rates": "/tasaCambio",
                patrimonio: "/heritage",
                heritage: "/heritage",
                niif: "/niif",
                "niif no controlante": "/niifNoControlante",
                "non-controlling interest niif": "/niifNoControlante",
                "grupos intercompañías": "/gruposintercos",
                "grupos intercompanias": "/gruposintercos",
                "intercompany groups": "/gruposintercos",
                "plan de cuentas": "/planCuentas",
                "plan de cuentas niif": "/planCuentas",
                "chart of accounts": "/planCuentas",
                "chart of account": "/planCuentas",
                chartAccounts: "/planCuentas",
                esquemas: "/planConsolidacion",
                schemes: "/planConsolidacion",
                compañías: "/company",
                compañias: "/company",
                companies: "/company",
                "efe directo": "/levelsDirectEfe",
                "direct method efe": "/levelsDirectEfe",
                "efe indirecto": "/nivelesadm/indirecto",
                "indirect method efe": "/nivelesadm/indirecto",
                "reporte ecp": "/ecpReporte",
                "ecp report": "/ecpReporte",
                "reporte ecp configuracion": "/ecpReporte",
                "reporte ori": "/oriReporte",
                "ori report": "/oriReporte",
                "reporte ori configuracion": "/oriReporte",
                ajustes: "/ajustesConsol",
                adjustments: "/ajustesConsol",
                reclasifica: "/reclasifica",
                reclassify: "/reclasifica",
                periodo: "/panelAdminPeriodo",
                period: "/panelAdminPeriodo",
                "redefinicion filas": "/redefinicionFilas",
                "row redefinition": "/redefinicionFilas",
                redefinicionfilas: "/redefinicionFilas",
                "niveles adm indirecto": "/nivelesadm/indirecto",
                "nivelesadm indirecto": "/nivelesadm/indirecto",
                "niveles adm": "/nivelesadm/indirecto",
                "nivelesadm": "/nivelesadm/indirecto"
            }

            // Verificar si el path ya existe en el router
            const existingRoute = this.$router.getRoutes().find(route => route.path === normalizedPath)
            if (existingRoute) {
                return normalizedPath
            }

            return routeMapByName[rawName] || normalizedPath || null
        },
        buildFallbackSubmenus() {
            return [
                {
                    id: "coins",
                    nombre: this.labels.coins,
                    descripcion: "Monedas",
                    ruta: "/currency",
                },
                {
                    id: "exchangeRates",
                    nombre: this.labels.exchangeRates,
                    descripcion: "Tasas de cambio",
                    ruta: "/tasaCambio",
                },
                {
                    id: "heritage",
                    nombre: this.labels.tasasPatrimonio,
                    descripcion: this.labels.tasasPatrimoniod,
                    ruta: "/heritage",
                },
                {
                    id: "niif",
                    nombre: this.labels.niif,
                    descripcion: "Niif",
                    ruta: "/niif",
                },
                {
                    id: "niifNoControlante",
                    nombre: this.labels.niifNoControlante,
                    descripcion: this.labels.niifNoControlanted,
                    ruta: "/niifNoControlante",
                },
                {
                    id: "gruposIntercos",
                    nombre: this.labels.gruposIntercos,
                    descripcion: this.labels.gruposIntercosd,
                    ruta: "/gruposintercos",
                },
                {
                    id: "chartAccounts",
                    nombre: this.labels.chartAccounts,
                    descripcion: "Plan de cuentas",
                    ruta: "/planCuentas",
                },
                {
                    id: "schemes",
                    nombre: this.labels.schemes,
                    descripcion: "Esquemas",
                    ruta: "/schemes",
                },
                {
                    id: "company",
                    nombre: this.labels.company,
                    descripcion: "Compañías",
                    ruta: "/company",
                },
                {
                    id: "levelsDirectEfe",
                    nombre: this.labels.levels,
                    descripcion: this.labels.levelsDirectEfe,
                    ruta: "/levelsDirectEfe",
                },
                {
                    id: "indirectLevel",
                    nombre: this.labels.indirectLevel,
                    descripcion: this.labels.levelIndirectEfe,
                    ruta: "/nivelesadm/indirecto",
                },
                {
                    id: "reporteECP",
                    nombre: this.labels.reporteECP,
                    descripcion: this.labels.reporteECPd,
                    ruta: "/ecpReporte",
                },
                {
                    id: "reporteORI",
                    nombre: this.labels.reporteORI,
                    descripcion: this.labels.reporteORId,
                    ruta: "/oriReporte",
                },
                {
                    id: "ajustes",
                    nombre: this.labels.ajustes,
                    descripcion: this.labels.ajustesd,
                    ruta: "/ajustes",
                },
                {
                    id: "reclasifica",
                    nombre: this.labels.reclasifica,
                    descripcion: this.labels.reclasificad,
                    ruta: "/reclasifica",
                },
                {
                    id: "periodo",
                    nombre: this.labels.periodo,
                    descripcion: this.labels.periodod,
                    ruta: "/panelAdminPeriodo",
                },
                {
                    id: "redefinicionfilas",
                    nombre: this.labels.redefinicionfilas,
                    descripcion: this.labels.redefinicionfilasd,
                    ruta: "/redefinicionFilas",
                },
                {
                    id: "nivelesAdmIndirecto",
                    nombre: "Niveles Adm Indirecto",
                    descripcion: "Administración de Niveles - Método Indirecto",
                    ruta: "/nivelesadm/indirecto",
                },
            ]
        },
        async loadSubmenus() {
            try {
                const menusResponse = await Menu.getAllMenu()
                const menus = menusResponse?.data?.listMenu || []
                const parametrizacionMenu = menus.find((menu) => {
                    const route = String(menu?.ruta || "").toLowerCase()
                    const name = String(menu?.nombre || "").toLowerCase()
                    return route === "parametrizacion" || route === "/parametrizacion" || name === "parametrizacion"
                })
                const menuId = parametrizacionMenu?.id || 3
                const res = await SubMenu.subMenuByMenuByRol(menuId, this.$store.state.userRole)
                this.listaSubMenu = (res?.data?.submenus || []).map((item) => ({
                    ...item,
                    ruta: this.resolveRoute(item),
                }))
            } catch (err) {
                console.log(err)
            }
        }
    },
    mounted() {
        this.loadSubmenus()
    }
}
</script>

<style src="../main.css"></style>

<style>
.parametrizacion-scroll-shell,
.main-menu-scroll-shell {
    height: 650px;
}
</style>